<template>
  <div>
    <template v-for="field in fields">
      <ValueHelpWrapper
        v-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        class="mb-2"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <RadioButtonWrapper
        v-else-if="field.type == 'radio-button'"
        :field="field"
        :value="formValues[field.name] || field.default"
        @input="$emit('update:formValues', { key: field.name, value: $event })"/>
      <FormulateInput v-else v-bind="field" class="mb-2"/>
    </template>
  </div>
</template>

<script>
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import RadioButtonWrapper from './wrapper/RadioButtonWrapper'
import { tableFilterFields } from './lib/tableFilterFields'

export default {
  components: {
    ValueHelpWrapper,
    RadioButtonWrapper,
  },
  mixins: [tableFilterFields],
  props: {
    formValues: {},
    fullObjects: {},
  },
  emits: ['update:formValues', 'update:fullObjects'],
  computed: {
    fields() {
      return this.tableFilterFields.filter(field => field.isShow)
    }
  }
}
</script>
